import React, { Fragment, Component } from 'react'
import CollapseMenu from '../../../../config/atoms/CollapseMenu';
import MenuDetail from '../MenuDetail';
import swal from 'sweetalert';
import { dataMahasiswa } from '../../../../dummy-data/mahasiswa';
import { dataKHS } from '../../../../dummy-data/krs-khs';

const $ = require("jquery");
$.Datatable = require("datatables.net");

class StatusMhs extends Component {

    state = {
        user: {
            nim: '',
            nama: ''
        },
        historisMhs: [],
        isLoading: true
    }

    getAllData = () => {
        const nim = this.state.nimVal;
        const mhs = dataMahasiswa.find(m => m.nim === nim);
        const khsData = dataKHS.filter(k => k.nim === nim);

        // Get unique semesters
        const semesters = [...new Set(khsData.map(k => k.semester_ke))].sort((a, b) => a - b);

        // Create history data
        const historyData = semesters.map(s => ({
            semester: s,
            status: 'Aktif'
        }));

        setTimeout(() => {
            this.setState({
                historisMhs: historyData,
                user: {
                    nim: nim,
                    nama: mhs ? mhs.nama : 'Mahasiswa Demo'
                },
                isLoading: false
            });
        }, 300);
    }

    setParams = () => {
        const queryParams = new URLSearchParams(window.location.search);
        this.setState({
            idVal: queryParams.get('id'),
            nimVal: queryParams.get('nim')
        }, () => {
            this.getAllData();
        })
    }

    handlerUpdate = (e, semester) => {
        swal({
            icon: 'success',
            title: 'Demo Mode',
            text: `Status semester ${semester} berhasil diubah ke ${e.target.value} (simulasi)`,
            timer: 1500,
            buttons: false
        });
    }

    componentDidMount = () => {
        document.getElementById("statusMhs").classList.add("active");
        CollapseMenu();
        this.setParams()
    };

    render() {
        return (
            <Fragment>
                <div className="col-md-12 mb-3">
                    <div className="row">
                        <div className="col-12 col-xl-8 mb-xl-0">
                            <p
                                className="abu"
                                style={{
                                    fontSize: "15px",
                                    fontWeight: "bold",
                                    color: "#999999",
                                    textTransform: "capitalize",
                                }}
                            >
                                Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;Data Mahasiswa&nbsp;&nbsp;&rsaquo;&nbsp;&nbsp;
                                Riwayat Status Mahasiswa
                            </p>
                        </div>
                        <div className="col-12 col-xl-4 sm-md-none">
                            <div className="justify-content-end d-flex ">
                                <div
                                    style={{ cursor: "pointer" }}
                                    title="expand/minimize"
                                    id="toogleMenu"
                                >
                                    <i className="fa fa-expand abu" id="iconQ"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row" id="smoothMain">
                    <div className="col-xl-3 order-xl-2 smoothTabs" id="menuKanan">
                        <MenuDetail id={this.state.idVal} nim={this.state.nimVal} />
                    </div>
                    <div className="col-xl-9" id="kontenKiri">
                        <div className="smooth mb-2">

                            {/* mata kuliah dibatalkan */}
                            <div className="card card-custom">
                                <div className="card-body">
                                    <p className="card-title text-center" style={{ fontSize: "25px", marginTop: "10px", marginBottom: "35px" }}>
                                        Status Mahasiswa
                                    </p>
                                    <div className="table-responsive pl-2 pr-2">
                                        <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                            <thead></thead>
                                            <tbody>
                                                <tr>
                                                    <td width={5}>Nama</td>
                                                    <td width={1}> : </td>
                                                    <td>{this.state.user.nama}</td>

                                                    <td width={5}>NIM</td>
                                                    <td width={1}> : </td>
                                                    <td>{this.state.user.nim}</td>
                                                </tr>
                                            </tbody>
                                        </table>
                                    </div>
                                    <br />
                                    <div className="table-responsive mt-1  pl-2 pr-2">
                                        {this.state.isLoading ?
                                            <div id="loaderMhs">
                                                <div className="loader-1 colorful mt-5 mb-2">
                                                    <div className="dot" />
                                                    <div className="dot" />
                                                    <div className="dot" />
                                                </div>
                                                <p align="center" className="mb-5">loading data...</p>
                                            </div>
                                            :
                                            <table className="display expandable-table tableBord table-striped" style={{ width: "100%" }}>
                                                <tbody>
                                                    {this.state.historisMhs.map((list, i) => {
                                                        return (
                                                            <tr key={i}>
                                                                <td>&#8226; &nbsp;&nbsp;Semester {list.semester}</td>
                                                                <td>
                                                                    <p align="right">
                                                                        <select className='form-control' style={{ width: '300px' }}
                                                                            defaultValue={list.status}
                                                                            onChange={(e) => this.handlerUpdate(e, list.semester)}>
                                                                            <option value="Aktif">Aktif</option>
                                                                            <option value="Non Aktif">Non Aktif</option>
                                                                            <option value="Cuti">Cuti</option>
                                                                            <option value="Sudah Ujian">Sudah Ujian</option>
                                                                            <option value="Lulus / Yudisium">Lulus / Yudisium</option>
                                                                            <option value="Keluar">Keluar</option>
                                                                            <option value="Drop Out (DO)">Drop Out (DO)</option>
                                                                            <option value="Meninggal">Meninggal</option>
                                                                        </select>
                                                                    </p>
                                                                </td>
                                                            </tr>
                                                        )
                                                    })}
                                                </tbody>
                                            </table>
                                        }
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Fragment>
        )
    }
}

export default StatusMhs
